var EHDI = EHDI || Object.create(null);

EHDI.scene.Preloader = function(){
    EHDI.aka.Container.call(this);

    EHDI.GAME.jsonManager = EHDI.JSONManager(null, EHDI.Assets.fetch("assets/preload/strings/strings.json"));

    var proximanova = new EHDI.aka.PixiText("hello world", {fontFamily: 'proximanova-black'});
    var exo = new EHDI.aka.PixiText("text", {fontFamily: 'Exo-Bold'});

    this.addChild(proximanova);
    this.addChild(exo);


    var bg = new PIXI.extras.TilingSprite(EHDI.Assets.images["gfx_bg"], EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight());

    this.addChild(bg);

    var loadingBorder = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_loading"]);
    loadingBorder.anchor.x = 0.5;
    loadingBorder.anchor.y = 0.5;
    loadingBorder.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.5);
    this.addChild(loadingBorder);
    
    var loadingBarBorder = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_loading_bar_con"]);
    loadingBarBorder.anchor.set(0.5, 0.5);
    loadingBarBorder.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.64);
    this.addChild(loadingBarBorder);

    var loadingStyle = EHDI.GAME.jsonManager.getLocale("STR_LOADING");
    var loadingText = new EHDI.displays.TextSprite(loadingStyle);
    loadingText.fontFamily = "Arial";
    setTimeout(function(){
        loadingText.style = loadingStyle.STYLE;
    }, 500);
    loadingText.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.316, EHDI.GAME.sceneManager.getStageHeight() * 0.595);
    this.addChild(loadingText);

    var loadingContainer = new EHDI.displays.FillRectangle(0x000000, 0, 0, 380, 27);
    loadingContainer.anchor.x = 0.5;
    loadingContainer.anchor.y = 0.5;
    loadingContainer.position.x = EHDI.GAME.sceneManager.getStageWidth() * 0.5;
    loadingContainer.position.y = EHDI.GAME.sceneManager.getStageHeight() * 0.65;
    this.addChild(loadingContainer);

    var loadingBar = new EHDI.displays.FillRectangle(0x1999F1, 0, 0, 380, 27);
    loadingContainer.addChild(loadingBar);
    loadingBar.x = -loadingContainer.width * 0.5;
    loadingBar.y = -loadingContainer.height * 0.5;

    var loadingWidth = loadingBar.width;
    var tapAnywhere = null;
    var tapAnywhereTimeline = null;

    EHDI.LoadManager.queueAssets(AssetDirectory.load);
    EHDI.LoadManager.start(startGame.bind(this));

    EHDI.GAME.updateManager.addFrameListener(update);

    var dbFactory = new dragonBones.PixiFactory();

    EHDI.DBoneFactory.start("gizmoloading_tex","gizmoloading_tex","gizmoloading_ske");
    var armature = EHDI.DBoneFactory.createArmature("Gizmo");
    dragonBones.WorldClock.clock.add(armature);
    armature.animation.gotoAndPlay(armature.animation.animationList[0], -1, -1, 0);
    armature.animation.play();
    var animationSprite = armature.getDisplay();;
    animationSprite.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.55);

    this.addChild(animationSprite);

    function update() {
        //console.log(EHDI.GAME.loader.getProgress());
        loadingBar.scale.x = EHDI.LoadManager.getProgress() / 100;
    };

    function startGame() {
        loadingBar.scale.x = EHDI.LoadManager.getProgress() / 100;
        EHDI.GAME.updateManager.removeFrameListener(update);

        EHDI.DBoneFactory.addToFactory("mustard_growth_tex","mustard_growth_tex","mustard_growth_ske");
        EHDI.DBoneFactory.addToFactory("combo_fx_tex","combo_fx_tex","combo_fx_ske");

        if(EHDI.BrowserInfo.isIOS) {
            tapAnywhere = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_TAP_CONT"));
            tapAnywhere.anchor.set(0.5, 0.5);
            tapAnywhere.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.65);
            this.addChild(tapAnywhere);
            tapAnywhere.alpha = 0;

            tapAnywhereTimeline = new TimelineMax();
            tapAnywhereTimeline.to(loadingText, 0.25, {alpha : 0}, 0);
            tapAnywhereTimeline.to(loadingContainer, 0.25, {alpha : 0}, 0);
            tapAnywhereTimeline.to(tapAnywhere, 0.25, {alpha : 1}, 0);
            tapAnywhereTimeline.add(function() {
                bg.interactive = true;
                tapAnywhereTimeline.kill();
                tapAnywhereTimeline = new TimelineMax({repeat : -1, repeatDelay : 1, delay : 1});
                tapAnywhereTimeline.to(tapAnywhere, 1, {alpha : 0});
                tapAnywhereTimeline.to(tapAnywhere, 0.5, {alpha : 1}, "+=0.2");
            });

            bg.touchstart = function() {
                bg.interactive = false;
                EHDI.GAME.soundManager.playSFX("button_sfx");
                EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), {alpha : new EHDI.scene.TransitionParameter(0,1), duration : 1});
            }
            
        } else {
            setTimeout(function(){
                EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), {alpha : new EHDI.scene.TransitionParameter(0,1), duration : 1})
            }, 500);
        }
        
    };

    this.screenDidDisappear = function(){
      //destroy
      EHDI.DBoneFactory.destroyArmature(armature);
      
      this.destroy({children : true});
    }
}


EHDI.scene.Preloader.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.loadScene = function setupLoader() {
    EHDI.GAME.sceneManager.changeScene(new EHDI.scene.Preloader());
}
